import React from "react";
import NumberedHeading from "./NumberedHeading";
import { useTranslation } from "react-i18next";

const DetailGrid = ({ number, title, example, data }) => {
  const { t } = useTranslation("result");
  return (
    <div className="py-10 px-[17rem] md-max:px-[1rem] flex flex-col gap-12">
      <NumberedHeading number={number} title={title} />
      <div className="grid grid-cols-2 md-max:grid-cols-1 gap-x-20 gap-y-8 md-max:gap-y-[20px]">
        {data?.slice(0, 6)?.map((item, index) => (
          <div key={index} className="flex gap-2.5">
            {/* <span className="text-2xl">🔹</span> */}
            <img src="/detail-grid-bullet-point.png" alt="" className="h-[25px] w-[25px]" />
            <div className="flex flex-col gap-2">
              <p className="text-xl font-semibold">{item?.title}</p>
              <p className="text-[#4B5563]">{item?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {example && (
        <p className="font-light text-[#4B5563] pl-10 -mt-5">
          <span className="text-lg font-normal mb-1 text-[#222222]">{t("example")}:</span> <br /> {example}
        </p>
      )}
    </div>
  );
};

export default DetailGrid;
